import { connect } from 'react-redux';

import {
  GET_PLACE_DETAIL,
  EDIT_CANCEL_POLICY,
  EDIT_POLICY_DEPOSIT,
  EDIT_POLICY_RECEIVE_ROOM,
  EDIT_POLICY_SMOKE_AND_PET,
  EDIT_POLICY_CURFEW,
  EDIT_OTHER_POLICY,
  CLEAR_PLACE_DETAIL,
  CLEAR_LIST_ROOM_OF_PLACE,
} from 'store/place/actionTypes';

import Policy from './Policy';

const mapStateToProps = (state) => ({
  isLoadingGetPlaceDetail: state.Place.isLoadingGetPlaceDetail,
  isLoadingEditCancelPolicy: state.Place.isLoadingEditCancelPolicy,
  isLoadingEditPolicyReceiveRoom: state.Place.isLoadingEditPolicyReceiveRoom,
  isLoadingEditPolicyDeposit: state.Place.isLoadingEditPolicyDeposit,
  isLoadingEditPolicySmokeAndPet: state.Place.isLoadingEditPolicySmokeAndPet,
  isLoadingEditPolicyCurfew: state.Place.isLoadingEditPolicyCurfew,
  isLoadingEditOtherPolicy: state.Place.isLoadingEditOtherPolicy,

  placeDetail: state.Place.placeDetail,
  setting: state.Setting.setting,
});

const mapDispatchToProps = {
  actionGetPlaceDetail: (payload) => ({
    type: GET_PLACE_DETAIL,
    payload,
  }),

  actionClearPlaceDetail: () => ({
    type: CLEAR_PLACE_DETAIL,
  }),

  actionClearListRoomsOfPlace: () => ({
    type: CLEAR_LIST_ROOM_OF_PLACE,
  }),

  actionEditCancelPolicy: (payload) => ({
    type: EDIT_CANCEL_POLICY,
    payload,
  }),

  actionEditReceiveRoomPolicy: (payload) => ({
    type: EDIT_POLICY_RECEIVE_ROOM,
    payload,
  }),

  actionEditDepositPolicy: (payload) => ({
    type: EDIT_POLICY_DEPOSIT,
    payload,
  }),

  actionEditSmokeAndPetPolicy: (payload) => ({
    type: EDIT_POLICY_SMOKE_AND_PET,
    payload,
  }),

  actionEditCurfewPolicy: (payload) => ({
    type: EDIT_POLICY_CURFEW,
    payload,
  }),

  actionEditOtherPolicy: (payload) => ({
    type: EDIT_OTHER_POLICY,
    payload,
  }),
};

export default connect(mapStateToProps, mapDispatchToProps)(Policy);
